import { useState } from 'react';
import { IBaseResponse } from '@nkr/models/index';
import { AuthActionCreators } from '@nkr/store/authorization';
import { useAppHookContext } from '@nkr/utils/rest-api';

interface IRetVal {
    saving: boolean,
    error: string,
    update: (id: number, deadline: string) => Promise<boolean>
}

function useUpdateCompletionDeadline(): IRetVal {
    const { dispatch } = useAppHookContext();

    const [saving, setSaving] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const update = async (id: number, deadline: string): Promise<boolean> => {
        setError('');
        setSaving(true);

        let options = {
            url: `${__API__}/admin/orders/${id}/completion-deadline?deadline=${encodeURIComponent(deadline)}`
        };

        try {
            const r: IBaseResponse = await dispatch(AuthActionCreators.apiPost(options));

            if (r.data.success) {
                return true;
            }

            setError(r.data.message || 'An error occurred while saving the deadline.');
            return false;
        } catch {
            setError('An error occurred while saving the deadline.');
            return false;
        } finally {
            setSaving(false);
        }
    };

    return { saving, error, update }
}

export default useUpdateCompletionDeadline;
